import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Modal from 'shared/components/NewModal/NewModal'
import Button from 'shared/components/Button/Button'

export default class InvoiceImportModal extends Component {
  static propTypes = {
    t: PropTypes.func,
    saveFormToInvoice: PropTypes.func,
    pathname: PropTypes.string
  }

  open () {
    this.modal.open()
  }

  render () {
    const {t, pathname, saveFormToInvoice} = this.props
    return (
      <Modal ref={(c) => { this.modal = c }}>
        <div className='modal-with-buttons'>
          <div className='texts'>
            <h1><b>{t('import', 'title').s}</b></h1>
            <h2>{t('import', 'text').s}</h2>
          </div>
          <div className='buttons'>
            <Button view='transparent-white' link={`${pathname}/events`} onClick={saveFormToInvoice}>{t('import', 'events').s}</Button>
            <Button view='transparent-white' link={`${pathname}/timesheets`} onClick={saveFormToInvoice}>{t('import', 'timesheet').s}</Button>
            <Button view='transparent-white' link={`${pathname}/mileageReports`} onClick={saveFormToInvoice}>{t('import', 'mileageReport').s}</Button>
            <Button view='transparent-white' link={`${pathname}/projects`} onClick={saveFormToInvoice}>{t('import', 'project').s}</Button>
          </div>
        </div>
      </Modal>
    )
  }
}
